<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-6">
                <help-text>
                    <h3>
                        Targets
                    </h3>

                    <p>
                        This panel displays the targets that have been set for the user by year.
                    </p>
                </help-text>
            </div>

            <div class="col-xs-18">
                <NewList
                    label="Month"
                    :targets="[{name: 'ad_revenue', label: 'Ad Revenue', width: 9}, {name: 'partnership_revenue', label: 'Partnership Revenue', width: 9}]"
                    :endpoint="'/api/v2/users/' + user.id + '/targets'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import HelpText from '@/components/HelpText'
import NewList from '../../../../../components/Panels/Administration/Targets/NewList'

export default {
    components: {NewList, HelpText},

    model: {
        prop: 'user',
        event: 'user-updated'
    },

    props: ['user']
}
</script>
